import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl" }, "Base Cost", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Create Group ")
const _hoisted_4 = { class: "my-3" }
const _hoisted_5 = { class: "card-header text-base" }
const _hoisted_6 = {
  class: "mr-3 font-bold",
  disabled: ""
}
const _hoisted_7 = { class: "flex justify-between items-center" }
const _hoisted_8 = { class: "filter-search" }
const _hoisted_9 = { class: "my-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Create Base Cost ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { class: "dialog-footer" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_IconSearch = _resolveComponent("IconSearch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Check = _resolveComponent("Check")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 24,
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, { onClick: _ctx.onShowAddBaseCost }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_plus)
                        ]),
                        _: 1
                      }),
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_collapse, {
                  modelValue: _ctx.state.collapseGroups,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.collapseGroups) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupWithLevel, (value, name) => {
                      return (_openBlock(), _createBlock(_component_el_collapse_item, {
                        title: `Level: ${name}`,
                        name: name,
                        key: name
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (gr, i) => {
                            return (_openBlock(), _createBlock(_component_el_card, {
                              key: i,
                              class: "my-3 relative"
                            }, {
                              header: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createElementVNode("span", null, [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(gr.name), 1),
                                    _createVNode(_component_el_link, {
                                      onClick: ($event: any) => (_ctx.onShowEditGroup(gr)),
                                      class: "ml-3",
                                      type: "primary",
                                      title: "Edit Group"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Edit)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_popconfirm, {
                                      "confirm-button-text": "Yes",
                                      "cancel-button-text": "No",
                                      icon: _ctx.InfoFilled,
                                      "icon-color": "red",
                                      title: "Are you sure to delete this?",
                                      onConfirm: ($event: any) => (_ctx.onDeleteGroup(gr.id)),
                                      class: "ml-3"
                                    }, {
                                      reference: _withCtx(() => [
                                        _createVNode(_component_el_link, {
                                          type: "danger",
                                          title: "Delete Group"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Delete)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["icon", "onConfirm"])
                                  ])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_el_row, {
                                      type: "flex",
                                      gutter: 20
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              placeholder: "Search",
                                              modelValue: gr.search,
                                              "onUpdate:modelValue": ($event: any) => ((gr.search) = $event),
                                              onKeyup: _withKeys(($event: any) => (_ctx.onSearchBaseCost(gr)), ["enter"])
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_el_button, {
                                                  icon: _ctx.IconSearch,
                                                  onClick: ($event: any) => (_ctx.onSearchBaseCost(gr))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_IconSearch)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["icon", "onClick"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_el_button, {
                                      onClick: ($event: any) => (
                      _ctx.router.push({
                        name: 'agency.baseCost.create',
                        params: { groupId: gr.id },
                      })
                      )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_plus)
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_10
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_el_table, {
                                    data: _ctx.state.baseCosts.filter(
                    b => b.group && b.group.id === gr.id
                  )
                    ,
                                    style: {"width":"100%"},
                                    stripe: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.columns, (column, index) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                          key: index,
                                          label: column.title,
                                          props: column.dataIndex,
                                          "min-width": column.minWidth,
                                          align: column.align
                                        }, {
                                          default: _withCtx((scope) => [
                                            (column.dataIndex === 'action')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                  _createVNode(_component_router_link, {
                                                    to: {
                              name: 'agency.baseCost.update',
                              params: { groupId: gr.id, id: scope.row.id },
                            },
                                                    class: "mr-3"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_button, {
                                                        size: "small",
                                                        type: "primary"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_el_icon, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_Edit)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to"]),
                                                  _createVNode(_component_el_popconfirm, {
                                                    "confirm-button-text": "Yes",
                                                    "cancel-button-text": "No",
                                                    icon: _ctx.InfoFilled,
                                                    "icon-color": "red",
                                                    title: "Are you sure to delete this?",
                                                    onConfirm: ($event: any) => (_ctx.onDeleteBaseCost(scope.row.id))
                                                  }, {
                                                    reference: _withCtx(() => [
                                                      _createVNode(_component_el_button, {
                                                        size: "small",
                                                        type: "danger"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_el_icon, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_Delete)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["icon", "onConfirm"])
                                                ]))
                                              : (column.dataIndex === 'name')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                    _createVNode(_component_router_link, {
                                                      to: {
                              name: 'agency.baseCost.update',
                              params: { groupId: gr.id, id: scope.row.id },
                            },
                                                      class: "base-cost"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["to"])
                                                  ]))
                                                : (column.dataIndex === 'default')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                      (scope.row[column.dataIndex])
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                            _createVNode(_component_el_button, {
                                                              type: "text",
                                                              class: "text-success",
                                                              title: "Use this for new sellers"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_el_icon, {
                                                                  size: 25,
                                                                  class: "font-bold"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_Check)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                            _createVNode(_component_el_button, {
                                                              type: "text",
                                                              class: "text-error"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_el_icon, {
                                                                  size: 25,
                                                                  class: "font-bold"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_Close)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]))
                                                    ]))
                                                  : (column.dataIndex === 'status')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                        (scope.row[column.dataIndex])
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Active "))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_18, "Inactive"))
                                                      ]))
                                                    : (column.dataIndex === 'createdAt')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                          _createElementVNode("span", null, _toDisplayString(_ctx.formatDateTime(scope.row[column.dataIndex])), 1)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row[column.dataIndex]), 1))
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "props", "min-width", "align"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["data"])
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["title", "name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.state.dialogVisible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dialogVisible) = $event)),
        title: `${_ctx.state.ruleForm.name ? 'Edit Base Cost Group' : 'Create Base Cost Group'
      }`,
        width: "55%"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.dialogVisible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_22,
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _hoisted_24,
                _hoisted_25
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "formBaseCost",
            model: _ctx.state.ruleForm,
            rules: _ctx.state.rules,
            "label-width": "25%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Group name",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.state.ruleForm.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.ruleForm.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Level",
                prop: "level"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.state.ruleForm.level,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.ruleForm.level) = $event)),
                    placeholder: "Select level"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: 1,
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: 2,
                        value: 2
                      }),
                      _createVNode(_component_el_option, {
                        value: 3,
                        label: 3
                      }),
                      _createVNode(_component_el_option, {
                        value: 4,
                        label: 4
                      }),
                      _createVNode(_component_el_option, {
                        value: 5,
                        label: 5
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }, 16))
}